// types
import { i18nHomePage } from 'models/i18n';

// ==============================|| I18N EN NAVIGATION ||============================== //

const skHomePage: i18nHomePage = {
  title: 'Systém riadenia energie EMS - AI EMS',
  emsPartyName: 'Meno subjektu',
  accountType: 'Rola subjektu',
  roles: 'Prihlásený ako',
  dateTime: 'Dátum a čas',
  AIEMSDescription:
    'AIEMS je softvérové riešenie - Systém riadenia energie (Energy Management System alebo EMS) s využitím prvkov umelej inteligencie (AI) umožňujúci jeho užívateľovi prístup na veľkoobchodné a vyrovnávacie energetické trhy v reálnom čase, poskytujúci rozhodovacie algoritmy a nástroje pre využitie energetických kapacít spravovaných zdrojov pre maximalizovanie výnosov z poskytovania energetických služieb a tým optimalizáciu spotreby a výroby, zlepšenie odolnosti siete, virtuálne skladovanie energie a presné predpovede správania sa ceny a vývoja trhu s elektrickou energiou.',
  appDescription:
    'V ľavej časti obrazovky sa nachádza menu a v pravej hornej časti je možné zmeniť jazyk, zmeniť subjekt pod ktorým je používateľ prihlásený alebo sa odhlásiť.'
};

export default skHomePage;
